<img [src]="imageSrc" [srcset]="srcset" [sizes]="sizes" height="100%" width="100%" class="position-fixed"
    style="object-fit: cover; object-position: center center; opacity: 0.85;" />
<div
    class="d-flex flex-column align-items-end align-content-end vertical-align-middle justify-content-start h-100 w-100"
    style="position: relative; z-index: 1;">
    <p class="display-3 p-5 fw-normal" style="text-shadow: white 1px 1px 10px; text-align: end;">
        Site under maintenance
    </p>
</div>
